import React, { useState } from "react";
import { Avatar, Box, IconButton, Input, Button, CircularProgress } from "@mui/material";
import CustomAppBar from "../../../foundation/CustomAppBar/CustomAppBar";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import ChatCard from "../../../foundation/ChatCard/ChatCard";
import { formatTimeIST } from "./utils/formatTime";
import logo from "../../../assets/wapsy_logo.png";

type Contact = {
  phone: string;
  lastText: string;
  lastSeen: string;
  messages: any[];
};

interface LeftPanelProps {
  contacts: Contact[];
  selectedPhone: string | null;
  onSelect: (phone: string) => void;
  hasMore?: boolean;
  onLoadMore?: () => void;
  loadingMore?: boolean;
}

export default function LeftPanel({ contacts, selectedPhone, onSelect, hasMore, onLoadMore, loadingMore }: LeftPanelProps) {
  const [searchText, setSearchText] = useState("");

  const filteredContacts = contacts.filter((c) =>
    c.phone.startsWith(searchText)
  );

  return (
    <Box height="100%" width="30%" overflow="hidden" sx={{ minHeight: 0 }}>
      <CustomAppBar>
        <Box
          width="100%"
          height="100%"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Avatar src={logo} alt="Wapsy Logo" sx={{ width: 40, height: 40 }} />

          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            pl="10px"
          >
            <span style={{ color: "white", fontWeight: "bold", fontSize: "14px" }}>Wapsy</span>
            <span style={{ color: "#8696a1", fontSize: "12px" }}>Admin Panel</span>
          </Box>
      </Box>
      </CustomAppBar>
      <Box
        sx={{
          background: "#101b20",
          padding: "12px",
        }}
        display="flex"
      >
        <Box
          display="flex"
          sx={{
            background: "#1f2c33",
            borderRadius: "8px",
            padding: "0px 8px",
          }}
          flex={1}
          alignItems="center"
        >
          <IconButton onClick={() => {}}>
            <SearchIcon
              sx={{
                color: "#8696a1",
                height: "20px",
                width: "20px",
              }}
            />
          </IconButton>
          <Input
            fullWidth
            disableUnderline
            placeholder="Search or start a new chat"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{
              height: "35px",
              color: "white",
              padding: "0px 13px",
              fontSize: "14px",
            }}
          />
        </Box>
        <IconButton onClick={() => {}}>
          <FilterListIcon
            sx={{
              color: "#8696a1",
              height: "20px",
              width: "20px",
            }}
          />
        </IconButton>
      </Box>
      <Box
        overflow="auto"
        height="90%"
        sx={{
          background: "#101b20",
        }}
      >
        {filteredContacts.map((c) => {
          const selected = selectedPhone === c.phone;
          const formattedTime = formatTimeIST(c.lastSeen);
          return (
            <Box key={c.phone} onClick={() => onSelect(c.phone)}>
              <ChatCard
                item={{
                  name: c.phone,
                  lastText: c.lastText,
                  lastSeen: formattedTime,
                  selected,
                }}
              />
            </Box>
          );
        })}
        <Box pt="50px" />
        {hasMore && (
          <Box display="flex" justifyContent="center" pb={2}>
            <Button
              variant="outlined"
              onClick={() => onLoadMore && onLoadMore()}
              disabled={!!loadingMore}
              sx={{ color: '#e8ecef', borderColor: '#2f3b44' }}
            >
              {loadingMore ? <CircularProgress size={18} color="inherit" /> : 'Load More'}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
